import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthGuard } from '../shared/security/auth.guard';
import { FirstTimeLoginComponent } from './first-time-login/first-time-login.component';
import { FormsModule, NG_VALIDATORS, ReactiveFormsModule } from '@angular/forms';
import { FirstTimeLoginService } from './first-time-login/firstTimeLogin.service';
import { PTLSharedModule } from '../shared/shared.module';
import { MatchValueDirective } from '../shared/directives/match-value.directive.directive';
import { LoginErrorComponent } from './login-error/login-error.component';
import { LoginComponent } from './login/login.component';
import { LoginService } from './login/login.service';
import { LoginRoutingModule } from './login-routing.module';
import { EmailComponent } from './email/email.component';




@NgModule({
  imports: [
    CommonModule,LoginRoutingModule, FormsModule,PTLSharedModule,ReactiveFormsModule
  ],
  declarations: [ResetPasswordComponent, FirstTimeLoginComponent,MatchValueDirective, LoginErrorComponent, LoginComponent, EmailComponent],
  providers :[FirstTimeLoginService, LoginService]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts